module.exports = __webpack_public_path__ + "img/solution4.cbcec9bf.png";